import React, { useEffect, useState, useImperativeHandle } from 'react';
import { Table, Button, message, Tooltip } from 'antd';
import { enhancedFormateTimeStamp } from '@/common/utils/format-time';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import apis from '../../../../apis';
import { getCrumb } from '@/components/bread-crumbs/cached-crumbs';
import { env } from '@/env';
import provideActivityLink from '@/components/provide-activity-link';
import { withRouter } from 'react-router-dom';
import './index.less';
import { linkWhereFrom } from '@/common/utils/helper';

const STATUSTYPE = ['', '未开始', '进行中', '已过期', '已下线'];

function Detail(props, ref) {
  const { pageType } = provideActivityLink.useActivityLink();
  const { data, towerId, otherData, planCode } = props;
  const { name, status, startTime, createErp, id, itemPoolActivityId } = data;
  const link =
    `activityId=${otherData.id}&pageId=${id}&activityName=${otherData.name}&pageName=${name}&item=${otherData.item}` +
    `&encryptActivityId=${otherData.encryptActivityId}&previewTime=${startTime}&beginDate=${otherData.startTime}` +
    `&endDate=${otherData.endTime}&activityBu=mall&activityType=active&mode=online` +
    (planCode ? `&planCode=${planCode}` : '') +
    (itemPoolActivityId ? `&poolActivityId=${itemPoolActivityId}` : '') +
    `&breadcrumbs=${encodeURIComponent(JSON.stringify(getCrumb({ hasDomain: true })))}`;
  // const baseLink = '/materials/babel#/editorDemo?'
  // const basePreviewLink = '/materials/babel#/editorDemo?/active/babelTower/index.html#/editor?'
  // const toLink = baseLink + link + '&' + provideActivityLink.themeActivityType.getThemeActivityTypeQuery(pageType)
  // const toPreviewLink = data.type === 0 ? env.BABEL_DOMAIN + '/active/babelTower/index.html#/editorDemo?' + link : basePreviewLink + link
  const toLink =
    env.BABEL_DOMAIN +
    '/active/babelTower/index.html#/editorDemo?' +
    link +
    '&' +
    provideActivityLink.themeActivityType.getThemeActivityTypeQuery(pageType);
  const realPageLink =
    env.BABEL_DOMAIN +
    '/active/babelTower/index.html#/editor?' +
    link +
    '&' +
    provideActivityLink.themeActivityType.getThemeActivityTypeQuery(pageType);
  const [dataList, setDataList] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const pageChange = (current, pageSize) => {
    setPagination({
      ...pagination,
      current: current,
    });
  };

  useImperativeHandle(ref, () => ({
    refresh: () => {
      setPagination({
        ...pagination,
        current: 1,
      });
    },
  }));

  const jump = () => {
    window.open(toLink);
  };

  const jumpBabel = () => {
    window.open(realPageLink);
  };

  // const jumpPreview = () => {
  //   window.open(toPreviewLink)
  // }

  const IconHover = (props) => {
    const { title, note } = props;
    return (
      <div>
        {title}
        <Tooltip placement="top" title={note}>
          <ExclamationCircleOutlined />
        </Tooltip>
      </div>
    );
  };

  const columns = [
    {
      title: '楼层',
      key: 'floorName',
      width: '25%',
      render: (_, record) => {
        return (
          <div>
            <div className="venueDetail__info__table__floorName">{record.floorName}</div>
            <div className="venueDetail__info__table__desc">{record.desc}</div>
          </div>
        );
      },
    },
    {
      title: () => <IconHover title="通天塔模版" note="该楼层通天塔模板名称" />,
      key: 'templateName',
      width: '25%',
      render: (_, record) => {
        return (
          <div className="venueDetail__info__table__templateName__wrapper">
            <img
              src={
                record.img
                  ? record.img
                  : 'https://img14.360buyimg.com/imagetools/jfs/t1/166430/19/18439/1355/60781908E646baf6c/fb299a28a183f9b1.png'
              }
              className="venueDetail__info__table__templateName__img"
            />
            <div>
              {record.templateName ? (
                <div className="venueDetail__info__table__templateName__detail">{record.templateName}</div>
              ) : (
                <div style={{ paddingLeft: 16 }}>
                  <div className="venueDetail__info__table__detail-title">未配置通天塔楼层</div>
                  <div className="venueDetail__info__table__detail-id">
                    <a href={realPageLink} target="_blank" rel="noopener noreferrer">
                      前去配置
                    </a>
                  </div>
                </div>
              )}
            </div>
          </div>
        );
      },
    },
    {
      title: () => <IconHover title="投放" note="投放平台生成的素材组ID" />,
      key: 'materialGroupId',
      width: '25%',
      render: (_, record) => {
        return (
          <div>
            {record.materialGroupId ? (
              <>
                <div className="venueDetail__info__table__detail-title">投放素材ID</div>
                <div className="venueDetail__info__table__detail-id">
                  {(record.materialGroupMap || []).map((item, key) =>
                    item.materialGroupId ? (
                      <>
                        <a
                          key={key}
                          href={linkWhereFrom(
                            Number(item.materialType) === 1
                              ? '/material/#/product/' + item.materialGroupId
                              : '/material/#/advert/' + item.materialGroupId
                          )}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {item.materialGroupId}
                        </a>
                        {key === record.materialGroupMap.length - 1 ? '' : ','}
                      </>
                    ) : null
                  )}
                </div>
              </>
            ) : (
              <>
                <div className="venueDetail__info__table__detail-title">未配置投放素材</div>
                <div className="venueDetail__info__table__detail-id">
                  <a href={realPageLink} target="_blank" rel="noopener noreferrer">
                    前去配置
                  </a>
                </div>
              </>
            )}
          </div>
        );
      },
    },
    {
      title: () => <IconHover title="提报" note="提报平台生成的收品池ID" />,
      key: 'itemPoolActivityId',
      width: '25%',
      render: (_, record) => {
        return (
          <div>
            {/* {record.itemPoolActivityId ? (
              <>
                <div className='venueDetail__info__table__detail-title'>提报收品池ID</div>
                <div className='venueDetail__info__table__detail-id'>
                  <a
                    href={env.MC_DOMAIN + '/dist/pages/activeManageBlock/page?activityId=' + activityId + '&blockId=' + record.itemPoolActivityId}
                  >{record.itemPoolActivityId}
                  </a>
                </div>
              </>
            ) : (
              <>
                <div className='venueDetail__info__table__detail-title'>未配置提报收品池</div>
                <div className='venueDetail__info__table__detail-id'>
                  <a
                    href={env.MC_DOMAIN + '/dist/pages/activeManageBlock/?activityId=' + activityId + '&tplCode=SYSTEM_WARE_TEMPLATE'}
                    target='_blank'
                    rel='noopener noreferrer'
                  >前去配置
                  </a>
                </div>
              </>
            )} */}
            {record.itemPoolId ? (
              <>
                <div className="venueDetail__info__table__detail-title">提报收品池ID</div>
                <div className="venueDetail__info__table__detail-id">
                  {record.materialGroupMap.map((item, index) =>
                    item.itemPoolId ? (
                      <>
                        <a
                          key={index}
                          href={
                            env.MC_DOMAIN +
                            '/dist/pages/activeManageBlock/?outSystem=1&entry=0&outerAreaId=' +
                            item.materialGroupId +
                            '&outerAreaType=' +
                            item.materialType
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {item.itemPoolId}
                        </a>
                        {index === record.materialGroupMap.length - 1 ? '' : ','}
                      </>
                    ) : null
                  )}
                </div>
              </>
            ) : (
              <div className="venueDetail__info__table__detail-title">未配置提报收品池</div>
            )}
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    apis
      .actRoomFloorList({
        towerId: towerId,
        pageId: id,
        platform: 0,
      })
      .then((res) => {
        const { ret, msg, data } = res;
        if (ret === '0') {
          setDataList(
            data.list.map((item, index) => ({
              key: index,
              ...item,
            }))
          );
        } else {
          message.error(msg);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, [towerId, id]);

  return (
    <>
      <div className="venueDetail__info-title">
        <div className="venueDetail__info-title__detail">
          <div className="venueDetail__info-title__detail__name">{name}</div>
          <div className="venueDetail__info-title__detail__status">
            <div className="venueDetail__info-title__detail__status__circle" style={{ background: 'red' }} />
            {STATUSTYPE[status]}
          </div>
          <div className="venueDetail__info-title__detail__divider" />
          <div className="venueDetail__info-title__detail__startTime">
            开始时间: {enhancedFormateTimeStamp(startTime)}
          </div>
          <div className="venueDetail__info-title__detail__createErp">创建人: {createErp}</div>
        </div>
        <div className="venueDetail__info-title__button-group">
          {/* {(status === '1' || status === '2') && <Button onClick={jumpPreview} style={{ color: 'rgba(0,0,0,0.65)' }}>预览页面</Button>} */}
          <Button onClick={jump}>页面Demo</Button>
          <Button onClick={jumpBabel} type="primary">
            页面搭建
          </Button>
        </div>
      </div>
      <Table
        dataSource={dataList}
        columns={columns}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          onChange: pageChange,
          showSizeChanger: false,
        }}
      />
    </>
  );
}

export default withRouter(React.forwardRef(Detail));
